import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { ModalActionButtons } from "@outschool/ui-legacy-component-library";
import React from "react";

import MuxVideoPlayer from "./MuxVideoPlayer";
import PageModal from "./PageModal";

type VideoModalProps = {
  videoPlaybackID: string;
  open: boolean;
  fullBleed?: boolean;
  onClose: (e?: any) => void;
  children?: React.ReactNode | React.ReactNode[];
};

export default function VideoModal({
  videoPlaybackID,
  open,
  onClose,
  children = null,
  fullBleed = false,
}: VideoModalProps) {
  const { t } = useTranslation("client\\components\\VideoModal");
  return (
    <PageModal open={open} onClose={onClose} fullBleed={fullBleed}>
      <Box
        sx={{
          padding: "1em",
        }}
      >
        <MuxVideoPlayer videoPlaybackID={videoPlaybackID} autoPlay />
      </Box>
      {children}
      <ModalActionButtons
        primaryLabel={t("Close")}
        hideCancelButton
        onPrimary={onClose}
      />
    </PageModal>
  );
}
